import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-screensTypeHorizont",
  "use": "svg-icon-screensTypeHorizont-usage",
  "viewBox": "0 0 14 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 8\" id=\"svg-icon-screensTypeHorizont\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-1-4h16v16H-1z\" /><path d=\"M0 0h14v8H0V0zm12 6H2V2h10v4z\" fill=\"#000\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol